type ImageLoaderProps = {
  src: string
  width: number
  quality?: number
}

const SHOPIFY_CDN_HOSTNAME = 'cdn.shopify.com'
const CONTENTFUL_CDN_HOSTNAME = 'images.ctfassets.net'
const DEFAULT_QUALITY = 75

function buildShopifyImageUrl(url: URL, width: number): string {
  const params = url.searchParams
  const originalWidth = Number(params.get('width'))
  const originalHeight = Number(params.get('height'))

  params.set('width', String(width))
  if (originalWidth && originalHeight) {
    params.set(
      'height',
      String(Math.round((width * originalHeight) / originalWidth))
    )
  }

  return `${url.origin}${url.pathname}?${params.toString()}`
}

function buildContentfulImageUrl(
  url: URL,
  width: number,
  quality: number
): string {
  const params = url.searchParams
  params.set('w', String(width))
  params.set('q', String(quality))
  if (!params.get('fm')) {
    params.set('fm', 'webp')
  }

  return `${url.origin}${url.pathname}?${params.toString()}`
}

export default function imageLoader({
  src,
  width,
  quality
}: ImageLoaderProps): string {
  try {
    const url = new URL(src)

    if (url.hostname === SHOPIFY_CDN_HOSTNAME) {
      return buildShopifyImageUrl(url, width)
    }

    if (url.hostname === CONTENTFUL_CDN_HOSTNAME) {
      return buildContentfulImageUrl(url, width, quality ?? DEFAULT_QUALITY)
    }

    return src
  } catch {
    return src
  }
}
